import { render, staticRenderFns } from "./bingli.vue?vue&type=template&id=e8cac168&"
import script from "./bingli.vue?vue&type=script&lang=js&"
export * from "./bingli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports